import { createContext } from 'react';

export const ScreenshotDataContext = createContext<{
  isAllDataForScreenshotLoaded: boolean;
  setSlideIsReady?: (ready: boolean) => void;
}>({
  isAllDataForScreenshotLoaded: false,
});

export const ScreenshotDataProvider = ScreenshotDataContext.Provider;
